import { Component, Input, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import {IFlowChartDataService} from "../../../services/flow-chart-data.service";

@Component({
    standalone: false,
    selector: 'particle-flow-chart-tab-view',
  templateUrl: './flow-chart-tab-view.component.html',
  styleUrls: ['./flow-chart-tab-view.component.scss']
})
export class FlowChartTabViewComponent implements OnInit {
  selectedFieldSectionIndex: number;
  @Input() sourceType: string;
  @Input() flowChartDataService: IFlowChartDataService;
  constructor() { }
  @Input() section: any;
  ngOnInit() {
    this.onTabIndexChange(0);
  }
  onTabIndexChange($event) {
    this.selectedFieldSectionIndex = $event;

  }
  onValueChanged(event) {


  }
}
